import type { StepType } from "@reactour/tour";
import { text, translateJadleToLocale } from "@quickpoint.me/shared";
import { fireClearCodeEvent } from "../../../editor/events";
import { typeSomeText } from "../../common";
import TourStepContent from "./wrapper";

const t = () => text.tourSteps;

function getActionTexts() {
	const s = t();
	return [
		translateJadleToLocale(`---\nimage: bauhaus \nimage: bauhaus colors\nimage: bauhausMusic\nimage: bauhaus1923\n  \n---\n${s.bauhausDescription}\n  size: 4.5\n-->\n`),
		"\n---",
		translateJadleToLocale("\nimage: bauhaus colors"),
		translateJadleToLocale("\nimage: bauhaus"),
		translateJadleToLocale("\nimage: bauhausMusic"),
		`\n${s.bauhausDescription}`,
		"\n-->",
		translateJadleToLocale("\nimage: bauhaus1923"),
		translateJadleToLocale(`---\n${s.bauhausDescriptionShort}\n|\nimage: bauhaus\nblank: 2\nimage: bauhaus colors\n|\nimage: bauhausMusic\nblank: 2\nimage: bauhaus1923\n-->\n`),
		translateJadleToLocale(` ${s.gridCellOne} \n  color:second\n  background:first\n`),
		translateJadleToLocale(` ${s.gridCellTwo} \n  color:second\n  background:first\n`),
		translateJadleToLocale(` ${s.gridCellThree} \n  color:second\n  background:first\n`),
		translateJadleToLocale(` ${s.gridCellFour} \n  color:second\n  background:first\n-->\n`),
	];
}

const grid: StepType[] = [
	{
		selector: ".author-root",
		position: "center",
		content: () => (
			<TourStepContent description={() => <strong>{text.tourSteps.gridTitle}</strong>} />
		),
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent description={() => text.tourSteps.gridIntro} />
		),
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{t().gridTypingPrefix} <span className="qp-tour-modifier">---</span> {text.tourSteps.gridTypingSuffix}
					</span>
				)}
			/>
		),
		position: "left",
		action: () => {
			fireClearCodeEvent();
			const a = getActionTexts();
			typeSomeText({ text: a[1] });
		},
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent description={() => text.tourSteps.gridAddImage} />
		),
		position: "left",
		action: () => {
			const a = getActionTexts();
			typeSomeText({ text: a[2] });
		},
	},
	{
		selector: ".qp-editor",
		position: "left",
		content: () => (
			<TourStepContent description={() => text.tourSteps.gridAdjacentCells} />
		),
		action: () => {
			const a = getActionTexts();
			typeSomeText({ text: a[3] });
		},
	},
	{
		selector: ".qp-editor",
		position: "left",
		content: () => (
			<TourStepContent description={() => text.tourSteps.gridRowsByDefault} />
		),
		action: () => {
			const a = getActionTexts();
			typeSomeText({ text: a[4] });
		},
	},
	{
		selector: ".qp-editor",
		position: "left",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.gridAddRowPrefix}{" "}
						<span className="qp-tour-modifier">---</span> {text.tourSteps.gridAddRowSuffix}
					</span>
				)}
			/>
		),
		action: () => {
			const a = getActionTexts();
			typeSomeText({ text: a[1] });
		},
	},
	{
		selector: ".qp-editor",
		position: "left",
		content: () => (
			<TourStepContent description={() => text.tourSteps.gridAddMoreContent} />
		),
		action: () => {
			const a = getActionTexts();
			typeSomeText({ text: a[5] });
		},
	},
	{
		selector: ".qp-editor",
		position: "left",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.gridEndGridPrefix}{" "}
						<span className="qp-tour-modifier">--{">"}</span> {text.tourSteps.gridEndGridSuffix}
					</span>
				)}
			/>
		),
		action: () => {
			const a = getActionTexts();
			typeSomeText({ text: a[6] });
		},
	},
	{
		selector: "#landscape-viewer",
		content: () => (
			<TourStepContent description={() => text.tourSteps.gridConsiderGrid} />
		),
		action: () => {
			fireClearCodeEvent();
			const a = getActionTexts();
			typeSomeText({ text: "", prefill: a[8] });
		},
	},
	{
		selector: ".cm-split-page-line.cm-line",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{t().gridYouType} <span className="qp-tour-modifier">|</span> {text.tourSteps.gridPipeColumns}
					</span>
				)}
			/>
		),
		action: () => {
			fireClearCodeEvent();
			const a = getActionTexts();
			typeSomeText({ text: "", prefill: a[8] });
		},
	},
	{
		selector: ".cm-line:nth-child(7)",
		content: () => (
			<TourStepContent
				description={() => text.tourSteps.gridColumnNotRows}
			/>
		),
	},
];

export default grid;
